import Image from 'next/image'

import styles from './styles.module.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faEye, faFileArrowDown, faMessage, faPaperPlane, faXmark } from '@fortawesome/free-solid-svg-icons'

import { motion } from 'framer-motion'
import { useEffect, useRef, useState } from 'react'

import { useSocket } from '../../../Context/socket'
import { useSession } from 'next-auth/react'
import axios from 'axios'
import { BarLoader, PuffLoader, PulseLoader } from 'react-spinners'
import errorMsg from '../../../Functions/errorMsg'

import JobListing from '../JobListing/JobListing'
import successMsg from '../../../Functions/successMsg'
import { useRouter } from 'next/router'

export default function AppliedJobs({ setPendingRequest }) {

  const { socket } = useSocket();
  const { data: session, status } = useSession();

  const [initialLoading, setInitialLoading] = useState(null);
  const [appliedJobs, setAppliedJobs] = useState(null);

  useEffect(() => {
    if(initialLoading !== null) return;
    if(appliedJobs !== null) return;
    if(status === 'loading') return;
    if(!session) return;

    async function getAppliedJobs() {
        setInitialLoading(true);
        setPendingRequest(true);

        const result = await axios.post(`${window.location.origin}/api/jobs/dashboard/getAppliedJobs`, {
          requestingUserID: session.user.token.id
        }).catch((error) => {
            errorMsg(error?.response?.data?.status || error.toString())
        })

        if(result && result.status === 200) {
          const data = result.data;
          setAppliedJobs(data);
        }

        setPendingRequest(false);
    }

    getAppliedJobs();

  }, [session, status])

  function isLoading() {
    if(status === 'loading') return true;
    if(initialLoading === false || initialLoading === null) return true;
    if(appliedJobs === null) return true;
    return false;
  }

  const [viewListingData, setViewListingData] = useState(null); // ListingID Stored

  return (
    <section id={styles.wrapper}>
      { viewListingData !== null && <JobListing listingID={viewListingData} closeListing={() => setViewListingData(null)} /> }

      { isLoading() === true && <section id={styles.loading}><PulseLoader size={30} color='#154734' /></section> }

      { isLoading() === false && (appliedJobs.length === 0 ?
        <div id={styles.noListings}>
          <h1>You have applied at no jobs</h1>
        </div>
        :
        <section id={styles.container}>
          {
            appliedJobs.map((listing, index) => {
              return <ListingCard key={index} session={session} listing={listing} setViewListingData={setViewListingData} />
            })
          }
        </section>
      )}

  </section>
  )
}

const ListingCard = ({ listing, setViewListingData }) => {

  const { socket } = useSocket();
  const { data: session, status } = useSession();

  const router = useRouter();

  const listingID = listing.jobID;
  const employerLogo = listing.businessLogo;

  const positionTitle = listing.positionTitle;

  const rateData = listing.rate;

  const [applicationStatus, setApplicationStatus] = useState(listing.status)

  const GetApplicationStatus = () => {
    if(applicationStatus === 'viewed') return <h2 style={{backgroundColor: 'purple', color: 'white'}}>Application Viewed</h2>
    if(applicationStatus === 'selected') return <h2 style={{backgroundColor: '#292929', color: 'white'}}>Application Selected</h2>
    if(applicationStatus === 'hired') return <h2 style={{backgroundColor: '#0da00d', color: 'white'}}>Marked Hired</h2>
    if(applicationStatus === 'withdrawn-employer') return <h2 style={{backgroundColor: '#CA0B00', color: 'white'}}>Not Eligible</h2>
    if(applicationStatus === 'withdrawn-user') return <h2 style={{backgroundColor: '#ffb005', color: 'black'}}>Application Withdrawn</h2>
    if(applicationStatus === null) return <h2 style={{backgroundColor: '#818181', color: 'white'}}>No Status</h2>
  }

  function showWithdrawButton() {
    if(applicationStatus === 'hired') return false;
    if(applicationStatus === 'withdrawn-employer') return false;
    if(applicationStatus === 'withdrawn-user') return false;
    return true;
  }

  function showMessageButton() {
    if(applicationStatus === 'withdrawn-employer') return false;
    if(applicationStatus === 'withdrawn-user') return false;
    return true;
  }

  const formatCurrency = (rate) => {
    let parsedRate = parseFloat(rate).toFixed(2);
    if (parsedRate.endsWith('.00')) {
      parsedRate = parsedRate.slice(0, -3);
    }
    parsedRate = parsedRate.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  
    return parsedRate;
  };
  
  const returnPayRate = () => {
    if (rateData.type === 'Hourly') {
      return `$${formatCurrency(rateData.rate)} / hr`;
    } else if (rateData.type === 'Salary') {
      return `$${formatCurrency(rateData.rate)} / yr`;
    }
  };

  const { displayString } = createdTimeStamp(listing.applied);

  const [loadingAction, setLoadingAction] = useState(false);



  const [confirmWithdrawApplication, showConfirmWithdrawApplication] = useState(false);

  async function handleWithdrawApplication() {
    if(loadingAction) return;
    showConfirmWithdrawApplication(false);

    setLoadingAction(true);

    const result = await axios.post(`${window.location.origin}/api/jobs/helpers/withdrawApplication`, {
      requestingUserID: session.user.token.id,
      jobID: listingID,
      userOfApplication: session.user.token.username
    }).catch((error) => {
        errorMsg(error?.response?.data?.status || error.toString())
    })

    if(result && result.status === 200) {
      setApplicationStatus('withdrawn-user')
    }

    setLoadingAction(false);
  }



  // Messaging Details

  const [pendingHandleMessageOperation, setPendingHandleMessageOperation] = useState(false);
  const [openNewMessage, setOpenNewMessage] = useState(null);

  async function handleMessageSellerOperation() {
    if(pendingHandleMessageOperation) return;
    if(!session) return;
    if(status !== 'authenticated') return;

    setPendingHandleMessageOperation(true);

    const result = await axios.post(`${window.location.origin}/api/messaging/hasActiveConvo`, {
        requestingUserID: session.user.token.id,
        otherUser: listing.owner,
        convoType: 'Jobs',
        listingID: listingID,
    }).catch((error) => {
        errorMsg(error?.response?.data?.status || error.toString());
    })

    if(result && result.status === 200) {
        const data = result.data;

        if(data.hasConvo) {
          handleOpenCurrentConversation(data.convoID);
        } else {
          setOpenNewMessage(true);
        }

    }

    setPendingHandleMessageOperation(false);

  }

  const handleOpenCurrentConversation = (convoID) => {
    const pathname = router.pathname;
    const query = { ...router.query, openConversationID: convoID };
  
    router.replace(
      {
        pathname: pathname,
        query: query,
      },
      undefined,
      {
        shallow: true,
      }
    );
  };


  const [pendingSend, setPendingSend] = useState(false);
  const messageRef = useRef(null);

  async function handleSendMessage(e) {
    e.preventDefault();
    if(status === 'loading') return;
    if(!socket) return;
    if(!session) return errorMsg("Please login to message this user.");
    if(status === 'unauthenticated') return errorMsg("Please login to message this user.");
    if(pendingSend === true) return;
    if(!messageRef || !messageRef.current) return;
    const messageText = messageRef.current.value;
    if(messageText.length === 0) return errorMsg("Please enter your message before sending.");
    if(messageText.length > 500) return errorMsg("Message cannot be over 500 characters.")
    
    const senderID = session.user.token.id;
    const sender = session.user.token.username;
    const toUser = listing.owner;

    if(!toUser) return errorMsg("Could not find the buyer, please contact us if the issue persists.");

    const basicConvoData = {
        type: 'Jobs',
        listingID: listingID,
        receiver: toUser,
        sender: sender,
        creationDate: new Date().toISOString()
    }

    setPendingSend(true);

    const result = await axios.post(`${window.location.origin}/api/messaging/create`, {
        conversationData: basicConvoData,
        messageText: messageText,
        senderID: senderID
    }).catch((error) => {
        errorMsg(error?.response?.data?.status || error.toString())
    });

    if(result && result.status === 200) {
        const newConvoData = result.data;

        socket.emit('createNewConversation', newConvoData)

        successMsg("Your message was sent.");

        setOpenNewMessage(false);
    }

    setPendingSend(false);
  }



  return (
    <div className={styles.card}>

      <div style={{display: openNewMessage ? 'flex' : 'none'}} id={styles.quickMessage}>
        <FontAwesomeIcon onClick={() => setOpenNewMessage(false)} icon={faXmark} id={styles.exit} />
        <h1>Message Employer</h1>
        <textarea ref={messageRef} placeholder="What's on your mind?" />
        <button onClick={handleSendMessage}> {pendingSend ? <BarLoader color='#4169E1' /> : <FontAwesomeIcon icon={faPaperPlane} /> } </button>
      </div>

      { confirmWithdrawApplication && <div id={styles.confirm}>
        <h1>Withdraw Application?</h1>
        <section>
            <button onClick={handleWithdrawApplication}>
                <FontAwesomeIcon icon={faCheck} id={styles.icon} />
            </button>
            <button onClick={() => showConfirmWithdrawApplication(false)}>
                <FontAwesomeIcon icon={faXmark} id={styles.icon} />
            </button>
        </section>
      </div> }

      { loadingAction && <div id={styles.loading}>
        <PuffLoader size={30} color='#818181' />
      </div> }

      <section>
        <div><Image sizes='auto auto' fill objectFit='cover' src={employerLogo} alt={employerLogo} /></div>
        <div>
          <h1>{returnPayRate()}</h1>
        </div>
      </section>

      <section>
        <h1>{positionTitle}</h1>
        <h3>Applied • {displayString}</h3>
        <GetApplicationStatus />
      </section>

      <section>
        <motion.button className={styles.withdraw} style={{display: showWithdrawButton() ? 'flex' : 'none'}} onClick={() => showConfirmWithdrawApplication(true)}>Withdraw<FontAwesomeIcon icon={faFileArrowDown} id={styles.icon} /></motion.button>
        <motion.button className={styles.message} style={{display: showMessageButton() ? 'flex' : 'none'}} onClick={handleMessageSellerOperation}> { pendingHandleMessageOperation ? <PuffLoader size={22} color='white' /> : <FontAwesomeIcon icon={faMessage} id={styles.icon} /> }  </motion.button>
        <motion.button className={styles.view} style={{display: !listing.userDeleted ? 'flex' : 'none'}} onClick={() => setViewListingData(listingID)}><FontAwesomeIcon icon={faEye} id={styles.icon} /></motion.button>
      </section>

    </div>
  )
}

function createdTimeStamp(creationDate) {
  const units = [
      { label: 'month', ms: 30 * 24 * 60 * 60 * 1000 },
      { label: 'week', ms: 7 * 24 * 60 * 60 * 1000 },
      { label: 'day', ms: 24 * 60 * 60 * 1000 },
      { label: 'hour', ms: 60 * 60 * 1000 },
      { label: 'minute', ms: 60 * 1000 },
      { label: 'second', ms: 1000 }
  ];

  const now = new Date().getTime();
  const delta = now - new Date(creationDate).getTime();
  let result = { displayString: "just now", justPosted: delta < units[2].ms };

  for (let { label, ms } of units) {
      const value = Math.floor(delta / ms);
      if (value >= 1) {
          result.displayString = `${value} ${label}${value > 1 ? 's' : ''} ago`;
          break;
      }
  }

  return result;
}